import { formatUrlDomain, hostRelativeReplaceAll } from './domainUtils';
import logger from '../../../../utils/logger';

/**
 * 处理url。将url中的域名处理为相对域名，而不是直接使用数据库中存储的固定域名。
 * @callback FormatUrlStringFunction
 * @param urlString 原始url地址
 * @param {HostRelativeOptionsType=} options 设置{@link HostRelativeOptionsType}
 * @returns {String} 转换后的url地址
 */
export const formatUrlString = (urlString, options = {}) => {
  if (!urlString) return urlString;
  return formatUrlDomain(urlString, options);
};

/**
 * @typedef {Object} ReportOptionsType
 * @property {string?} reportEvent 上报event名，会作为report-event加在a标签中
 * @property {string?} reportEventGoal 上报event-goal名，会作为report-event-Goal加在a标签中
 */

/**
 * 对html中的a标签进行处理，加上上报参数
 * @param {string} htmlString 字符串格式的html内容
 * @param {ReportOptionsType} options 可传入{reportEvent}来设置上报event名
 * @returns {string} 处理后的html内容
 */
function formatATagInHtml(htmlString, options = {}) {
  const reportEvent = options?.reportEvent || 'click_richtext_href';
  const reportEventGoal = options?.reportEventGoal || 'click_richtext_href'; // click_learn_more
  // console.log('formatATagInHtml ready', htmlString);
  let ret = htmlString;
  try {
    ret = htmlString.replace(/<a(.*?href=["'])(.+?)(["'].*?)>(.*?)<\/a>/g, (match, p1, href, p3, text) => {
      const reportEventProperties = `report-event-goal="${reportEventGoal}" report-event="${reportEvent}" report-ext1="${text}" report-ext2="${href}"`; // 上报用的属性
      const handled = `<a${p1}${href}${p3} ${reportEventProperties} >${text}</a>`;
      // console.log('formatATagInHtml replace', { match, handled, part: { p1, href, p3, text } });
      return handled;
    });
    // console.log('formatATagInHtml over', { origin: htmlString, after: ret });
    // if (ret !== htmlString) {
    //   logger.info(`formatATagInHtml success: ${JSON.stringify({
    //     origin: htmlString,
    //     after: ret,
    //   })}`);
    // }
  } catch (e) {
    logger.error(`[formatATagInHtml] error: ${JSON.stringify({ e, htmlString })}`);
  }
  return ret;
}

/**
 * 处理一篇文本中含有的所有url。将url中的域名处理为相对域名，而不是直接使用数据库中存储的固定域名。
 * @callback FormatUrlInTextFunction
 * @param {string} text 原始文本
 * @param {(HostRelativeOptionsType & ReportOptionsType)=} options
 * 设置域名{@link HostRelativeOptionsType}或上报{@link ReportOptionsType}
 * @returns {String} 转换后的文本
 */
export const formatUrlInText = (text, options = {}) => {
  if (!text) return text;
  let ret = hostRelativeReplaceAll(text, options);
  ret = formatATagInHtml(ret, options);
  return ret;
};

/**
 * 传入域名，获取url处理的方法
 * @param {{domains?: DomainInfosType}} options 配置，传入域名{domainInfos}
 * @returns {{formatUrlInText: FormatUrlInTextFunction, formatUrlString: FormatUrlStringFunction}} url处理函数
 */
export function getFormatUrlMethods({ domains }) {
  /**
   * @type {FormatUrlInTextFunction}
   */
  const formatUrlInTextWithDomain = (text, otherOptions = {}) => {
    return formatUrlInText(text, { domainInfos: domains, ...(otherOptions || {}) });
  };

  /**
   * @type {FormatUrlStringFunction}
   */
  const formatUrlStringWithDomain = (urlString, otherOptions = {}) => {
    return formatUrlString(urlString, { domainInfos: domains, ...(otherOptions || {}) });
  };

  return { formatUrlInText: formatUrlInTextWithDomain, formatUrlString: formatUrlStringWithDomain };
}
